module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('basic-button'), _vm._v(" "), _c('naked-button'), _vm._v(" "), _c('external-button')], 1)
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-b7ee4a52!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/canvas/triggerbutton/Main.vue
 ** module id = 903
 ** module chunks = 1
 **/